"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.useMatchBreakpoint = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _theme = require("../styles/theme");

var _useTheme = _interopRequireDefault(require("../styles/useTheme"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
/**
 * Function that matches the breakpoint value in px, defined in Theme.breakpoint.values and returns the matched key
 * with help of [window.matchMedia](https://developer.mozilla.org/fr/docs/Web/API/Window/matchMedia)
 * If things go wrong, we pick the highest bp available
 */


var matchBreakpoints = function matchBreakpoints(theme) {
  // We need the keys in DESC order here
  var keys = _theme.breakpointKeys.slice().reverse();

  if (typeof window !== 'undefined') {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value; // match media query

        if (window.matchMedia("(min-width: ".concat(theme.breakpoint.values[key], "px)")).matches) {
          return key;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
          _iterator["return"]();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return keys[0];
};
/**
 * Returns the current matching breakpoint ('xs', 'sm', ...) based on Theme context values
 */


var useBreakpoint = function useBreakpoint() {
  var theme = (0, _useTheme["default"])();

  var _useState = (0, _react.useState)(matchBreakpoints(theme)),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      breakpoint = _useState2[0],
      setBreakpoint = _useState2[1]; // memoize the callback


  var handleResize = (0, _react.useCallback)(function () {
    return setBreakpoint(matchBreakpoints(theme));
  }, [theme, setBreakpoint]); // handle theme changes

  (0, _react.useEffect)(function () {
    return void handleResize();
  }, [theme]); // handle window resize events

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
      return function () {
        return window.removeEventListener('resize', handleResize);
      };
    }

    return undefined;
  }, [handleResize]);
  return breakpoint;
};
/**
 * An iteration of `useBreakpoint` defined just above
 * It tells you if the current breakpoint is in the array of bps you passed as argument
 */


__signature__(useBreakpoint, "useTheme{theme}\nuseState{[breakpoint, setBreakpoint](matchBreakpoints(theme))}\nuseCallback{handleResize}\nuseEffect{}\nuseEffect{}", function () {
  return [_useTheme["default"]];
});

var useMatchBreakpoint = function useMatchBreakpoint(bps) {
  var bp = useBreakpoint();
  return (0, _react.useMemo)(function () {
    return bps.indexOf(bp) > -1;
  }, [bp].concat((0, _toConsumableArray2["default"])(bps)));
};

exports.useMatchBreakpoint = useMatchBreakpoint;

__signature__(useMatchBreakpoint, "useBreakpoint{bp}\nuseMemo{}", function () {
  return [useBreakpoint];
});

var _default = useBreakpoint;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(matchBreakpoints, "matchBreakpoints", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useBreakpoint.ts");
  reactHotLoader.register(useBreakpoint, "useBreakpoint", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useBreakpoint.ts");
  reactHotLoader.register(useMatchBreakpoint, "useMatchBreakpoint", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useBreakpoint.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useBreakpoint.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();